@if(component && !component.hideTrustpilot) {
<!-- The vendored widget only reserves 24px until Trustpilot's script injects the
     iframe, so hold the slot at its final height here to avoid a layout shift. -->
<div class="block" [style.minHeight]="component.styleHeight || '140px'">
<trustpilot-widget [locale]="'en-US'"
                   [templateId]="component.templateId"
                   [businessunitId]="component.businessunitId"
                   [styleHeight]="component.styleHeight || '140px'"
                   [styleWidth]="component.styleWidth || '100%'"
                   [theme]="component.theme || 'light'"
                   [stars]="component.stars || '4,5'"
                   [noReviews]="'collapse'"
                   [reviewLanguages]="component.reviewLanguages || 'en'" />
</div>
}
